import { createSlice } from '@reduxjs/toolkit';

import { clearSessionCase } from './cases/clearSession';
import { impersonateCase } from './cases/impersonate';
import { loginFulfilledCase } from './cases/loginFilfilled';
import { loginPendingCase } from './cases/loginPending';
import { loginRejectedCase } from './cases/loginRejected';
import { logoutImpersonationCase } from './cases/logoutImpersonation';
import { setSessionCase } from './cases/setSession';
import { updateTokenCase } from './cases/updateToken';
import { initialStateSession } from './initialStates';
import { login } from './login';

const slice = createSlice({
  name: 'Session',
  initialState: initialStateSession,
  reducers: {
    updateToken: updateTokenCase,
    setSession: setSessionCase,
    clearSession: clearSessionCase,
    impersonate: impersonateCase,
    logoutImpersonation: logoutImpersonationCase,
  },
  extraReducers: builder => {
    builder.addCase(login.fulfilled, loginFulfilledCase);
    builder.addCase(login.pending, loginPendingCase);
    builder.addCase(login.rejected, loginRejectedCase);
  },
});

const { reducer } = slice;

export const {
  setSession,
  clearSession,
  updateToken,
  impersonate,
  logoutImpersonation,
} = slice.actions;

export default reducer;
